import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import GetClientDatabaseTypesQuery from '@/graphql/contracts/getClientDatabaseTypes.query.gql';
import { notificationService } from '@/services/notification/notification.client';
import { GetClientDatabaseTypes, GetClientDatabaseTypesVariables } from
  '@/graphql/contracts/_generated_/getClientDatabaseTypes.query';


export default function useGetClientDatabases() {
  const { data, error, loading } = useQuery<GetClientDatabaseTypes, GetClientDatabaseTypesVariables>(
    GetClientDatabaseTypesQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  return {
    databaseList: data?.clientDatabases ?? [],
    isDatabaseListLoading: loading,
    errorLoadingDatabaseList: error,
  } as const;
}
